import { useNavigate } from "react-router-dom";

// Footer.tsx
export function Footer() {
  const navigate = useNavigate()
  const handleAdminClick = () => {
  const password = window.prompt("Enter admin password:");
  if (password === "admin@adminKA1055") {
    sessionStorage.setItem("adminAuth", "true"); // ✅ store auth
    navigate("/admin");
  } else if (password !== null) {
    alert("Incorrect password.");
  }
};
  
  return (
    <footer className="py-16 px-6 border-t border-neutral-200">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between gap-8 text-sm text-neutral-600">
        <div>
          <p className="font-medium text-black">Qneect</p>
          <p onClick={handleAdminClick} className="cursor-pointer">Premium digital desk bell system</p>
        </div>

        <div className="flex gap-6">
          <span className="cursor-pointer">Twitter</span>
          <span className="cursor-pointer">LinkedIn</span>
          <a
            href="https://www.instagram.com/qneect.in?igsh=aTJodWR6M2oyYjVp"
            target="_blank"
            rel="noopener noreferrer"
            className="cursor-pointer"
          >
            Instagram
          </a>
        </div>
      </div>

      <p className="text-center text-xs text-neutral-400 mt-12">
        © {new Date().getFullYear()} Qneect. All rights reserved.
      </p>
    </footer>
  );
}
